import { createAction, props } from '@ngrx/store';
import { LoadingActionTypes } from 'src/app/store/auth-store/auth-types';

export const startAuthLoadingAction = createAction(
  LoadingActionTypes.START_LOADING
);

export const finishAuthLoadingAction = createAction(
  LoadingActionTypes.FINISH_LOADING
);

export const setAuthErrorAction = createAction(
  LoadingActionTypes.SET_ERROR,
  props<{ payload: { error: any } }>()
);
